export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_VERTICALS_SUCCESS = 'FETCH_VERTICALS_SUCCESS';
export const FETCH_VERTICAL_SUCCESS = 'FETCH_VERTICAL_SUCCESS';
export const SELECT_VERTICAL = 'SELECT_VERTICAL';
export const HIDE_LOADER = 'HIDE_LOADER';
